import { useEffect, useState } from "react";
import { cloGet, ENDPOINTS } from "./api";

export const useRetailers = (): any[] => {
  const [retailers, setRetailers] = useState<any[]>([]);
  useEffect(() => {
    cloGet(ENDPOINTS.CLO_RETAILERS, { page: 1, pageSize: 100 })
      .then((res) => setRetailers(res.data || []))
      .catch(() => setRetailers([]));
  }, []);
  return retailers;
};
